export default __webpack_public_path__ + "static/revolutionizing-civic-recruitment-with-registration-management-system-c063241cfbfe73186f55f39e749a288a.png";